import { render, staticRenderFns } from "./CTReadingIncorrect.UK.2.vue?vue&type=template&id=6fcbde42&scoped=true"
import script from "./CTReadingIncorrect.UK.2.vue?vue&type=script&lang=js"
export * from "./CTReadingIncorrect.UK.2.vue?vue&type=script&lang=js"
import style0 from "./CTReadingIncorrect.UK.2.vue?vue&type=style&index=0&id=6fcbde42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcbde42",
  null
  
)

export default component.exports